function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';
import { stylePropTypes } from '@dkrm/general-libs/theme/styles';
export default class HoverableView extends Component {
  constructor(props) {
    super(props);
    this.setStyles = styles => {
      this.rootRef.current.setNativeProps({
        style: styles
      });
    };
    this.handleMouseEnter = () => {
      this.setStyles([this.props.style, this.props.hoverStyle]);
      this.props.onHover();
    };
    this.handleMouseLeave = () => {
      this.setStyles(this.props.style);
      this.props.onLeave();
    };
    this.rootRef = /*#__PURE__*/React.createRef();
  }
  render() {
    const {
      hoverStyle,
      style,
      onHover,
      onLeave,
      ...rest
    } = this.props;
    return /*#__PURE__*/React.createElement(View, _extends({
      ref: this.rootRef,
      onMouseEnter: this.handleMouseEnter,
      onMouseLeave: this.handleMouseLeave,
      style: style
    }, rest));
  }
}
HoverableView.defaultProps = {
  onHover: () => null,
  onLeave: () => null,
  style: null,
  hoverStyle: null
};
HoverableView.propTypes = process.env.NODE_ENV !== "production" ? {
  onHover: PropTypes.func,
  onLeave: PropTypes.func,
  style: stylePropTypes,
  hoverStyle: stylePropTypes
} : {};